export default "__VITE_ASSET__44ae2268__"